import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import FontIcon from 'material-ui/FontIcon';
import MenuItem from 'material-ui/MenuItem';
import TokenManager from 'accessTokens/TokenManager';

class Logout extends PureComponent {

    constructor(props) {
        super(props);
        this.logout = this
            .logout
            .bind(this);

    }

    logout(e) {
        const { toggleDrawer, statusActions, user, messageActions, history } = this.props;
        e.preventDefault();
        toggleDrawer('leftDrawer', false);

        const userId = user.get('userId');

        messageActions.publishMessage({
            action: 'Logout',
            instanceId: user.get('instanceId')
        }, userId);

        statusActions.setTechStatusNotReady({
            techStatusChange: {
                userId: userId,
                techStatusWorkOrder: {},
                techStatus: "NotReady"
            },
            channels: [userId]
        }, userId);

        TokenManager.logout();

        history.push('/login');
    }

    render() {
        const { isMenuItem } = this.props;

        const icon = (
            <FontIcon className="material-icons">power</FontIcon>
        );
        const link = (<Link to="/login"/>);

        if (isMenuItem) {

            return (<MenuItem
                onTouchTap={this.logout}
                containerElement={link}
                leftIcon={icon}
                primaryText="Logout"/>);
        }

        return (<FlatButton
            onTouchTap={this.logout}
            containerElement={link}
            icon={icon}
            label="Logout"/>);

    }
}

Logout.propTypes = {
    isMenuItem: PropTypes.bool,
    toggleDrawer: PropTypes.func,
    statusActions: PropTypes.object,
    user: PropTypes.object,
    messageActions: PropTypes.object,
    history: PropTypes.object
};

export default Logout;



// WEBPACK FOOTER //
// ./src/components/layout/Logout.js